/**
 * Redirect utility for cross-domain navigation
 * Handles redirecting from foundersmate.ai to app.foundersmate.ai
 * while preserving authentication cookies
 */

/**
 * Redirect to app.foundersmate.ai with optional path
 * @param path - Optional path to append to app.foundersmate.ai (e.g., '/dashboard')
 * @param preserveAuth - Whether to preserve authentication (default: true)
 */
export const redirectToApp = (path: string = '', preserveAuth: boolean = true): void => {
  const baseUrl = 'https://app.foundersmate.ai';
  const targetUrl = path ? `${baseUrl}${path.startsWith('/') ? path : `/${path}`}` : baseUrl;
  
  if (preserveAuth) {
    // Cookies are already set with domain .foundersmate.ai, so they'll be available
    // Just redirect - the cookies will be sent automatically
    window.location.href = targetUrl;
  } else {
    window.location.href = targetUrl;
  }
};

/**
 * Check if we're on foundersmate.ai and should redirect to app.foundersmate.ai
 * This can be called on app initialization
 */
export const checkAndRedirect = (): void => {
  const hostname = window.location.hostname;
  
  // If we're on foundersmate.ai (not app.foundersmate.ai), redirect
  if (hostname === 'foundersmate.ai' || hostname === 'www.foundersmate.ai') {
    // Check if user is authenticated (has token in localStorage or cookie)
    const token = localStorage.getItem('token') || document.cookie.includes('authToken');
    
    if (token) {
      // User is authenticated, redirect to app
      redirectToApp();
    } else {
      // User is not authenticated, redirect to login on app
      redirectToApp('/login');
    }
  }
};
